import { render } from "./ChatTemplateDropdown.vue?vue&type=template&id=dc403cac&scoped=true&ts=true"
import script from "./ChatTemplateDropdown.vue?vue&type=script&lang=ts"
export * from "./ChatTemplateDropdown.vue?vue&type=script&lang=ts"

import "./ChatTemplateDropdown.vue?vue&type=style&index=0&id=dc403cac&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dc403cac"]])

export default __exports__